'use client';
import React, { useState, useEffect } from 'react';

const SharePostIcons = ({ blogTitle }) => {
    const [currentUrl, setCurrentUrl] = useState('');

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setCurrentUrl(window.location.href);
        }
    }, []);

    const encodedBlogTitle = encodeURIComponent(blogTitle);

    return (
        <div className="social-icons">
            {/* <a
                href="https://www.instagram.com/munich.indians"
                target="_blank"
                rel="noopener noreferrer"
            >
                <img src={instagram} alt="Instagram" />
            </a> */}

            <a
                href={`https://www.facebook.com/sharer/sharer.php?u=${currentUrl}`}
                target="_blank"
                rel="noopener noreferrer"
            >
                <img src="/images/Footer/facebook.png" alt="Share on Facebook" width={24} height={24} />
            </a>

            <a
                href={`https://twitter.com/intent/tweet?text=${encodedBlogTitle}%0A${encodeURIComponent(currentUrl)}`}
                target="_blank"
                rel="noopener noreferrer"
            >
                <img src="/images/Footer/twitter.png" alt="Share on Twitter" width={24} height={24} />
            </a>


            <a
                href={`https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(currentUrl)}&text=${encodedBlogTitle}%0A${encodeURIComponent(currentUrl)}`}
                target="_blank"
                rel="noopener noreferrer"
            >
                <img src="/images/Footer/linkedIn.png" alt="Share on LinkedIn" width={24} height={24} />
            </a>

        </div>
    );
};

export default SharePostIcons;
